import _ from "lodash";
import moment from "moment";

const removeWhiteSpace = text => text.replace(/\s/g, "");

export const DEFAULT_ERROR_MESSAGE = "Default Server Error";

const getErrorResponseMessage = (response, defaultMessage) => {
	let errorMessage = defaultMessage || DEFAULT_ERROR_MESSAGE;

	const message = _.get(response, "0.message");
	if (message) {
		errorMessage = message;
	}

	return errorMessage;
};

const getDataResponse = response => {
	if (response.data && response.data.error_code !== 0) {
		throw response.data;
	} else {
		return response.data.data;
	}
};

export default {
	checkToken (error) {
		if (error.message && error.message.includes('status code 403')) {
			if (localStorage.getItem("accessToken")) {
				localStorage.removeItem("accessToken");
				localStorage.removeItem("userInfo");
				// location.reload();
				window.location = '/';
			}
		}
	},
	getErrorResponseMessage,
	getDataResponse,
	notifyError: ({ context, error, options }) => {
		const title = context.$t(`Notify.${removeWhiteSpace("Error Title")}`);
		const message = error ? error.message || error.errors : context.$t(`Notify.${removeWhiteSpace(DEFAULT_ERROR_MESSAGE)}`);

		return context.$vs.notify({
			title: title,
			text: message,
			iconPack: "feather",
			icon: "icon-alert-circle",
			color: "danger",
			time: 30000,
			...options
		});
	},

	notifySuccess: ({ context, options }) => {
		return context.$vs.notify({
			title: context.$t(`Notify.Notification`),
			text: context.$t(removeWhiteSpace(`Notify.Handle Successful`)),
			iconPack: "feather",
			icon: "icon-alert-circle",
			color: "success",
			time: 5000,
			...options
		});
	},

	notifyWarning: ({ context, options }) => {
		return context.$vs.notify({
			title: context.$t(`Notify.Notification`),
			iconPack: "feather",
			icon: "icon-alert-circle",
			color: "warning",
			time: 5000,
			...options
		});
	},
	getStausShippingAqua(status) {
		let name = '-';
		let directive = 'default';
		switch (status) {
			case 0: {
				name = 'Đang chờ';
				directive = 'info';
				break;
			}
			case 1: {
				name = 'Không đạt';
				directive = 'warning';
				break;
			}
			case 2: {
				name = 'Hoàn thành';
				directive = 'primary';
				break;
			}
		}
		let directiveObj = {label:1};
		directiveObj['text-'+directive] = 1;
		return {name: name, directive: directiveObj};
	},
	getStatusAndDirectiveBillingAqua(status) {
		let name = 'Đang chờ TT';
		let directive = 'info';
		switch (status) {
			case 0: {
				name = 'Đang chờ';
				directive = 'info';
				break;
			}
			case 1: {
				name = 'Đang chờ UNC';
				directive = 'warning';
				break;
			}
			case 16: {
				name = 'TT một phần';
				directive = 'warning';
				break;
			}
			case 2: {
				name = 'Đã thanh toán';
				directive = 'primary';
				break;
			}
		}
		let directiveObj = {label:1};
		directiveObj['text-'+directive] = 1;
		return {name: name, directive: directiveObj};
	},

	getStatusAndDirectiveSoKCS(status) {
		let name = 'Chờ xuất';
		let directive = 'info';
		switch (status) {
			case 3: {
				name = 'Đã hủy';
				directive = 'warning';
				break;
			}
			case 4: {
				name = 'Hoàn thành';
				directive = 'primary';
				break;
			}
		}
		let directiveObj = {label:1};
		directiveObj['text-'+directive] = 1;
		return {name: name, directive: directiveObj};
	},
	


	getStatus(status) {
		let name = '-';
		switch (status) {
			case 0: {
				name = 'Đang chờ';
				break;
			}
			case 64: {
				name = 'Đã KTCL';
				break;
			}
			case 1: {
				name = 'Sản phẩm phù hợp';
				break;
			}
			case 2: {
				name = 'Đề xuất giao dịch';
				break;
			}
			case 4: {
				name = 'Duyệt mua';
				break;
			}
			case 8: {
				name = 'Đã từ chối';
				break;
			}
			case 16: {
				name = 'Đã hủy';
				break;
			}
		}
		return name;
	},
	getStatusAndDirectiveBilling(status) {
		let name = 'Đang chờ TT';
		let directive = 'info';
		switch (status) {
			case 1: {
				name = 'TT một phần';
				directive = 'warning';
				break;
			}
			case 2: {
				name = 'Đã thanh toán';
				directive = 'dark';
				break;
			}
		}
		let directiveObj = {label:1};
		directiveObj['text-'+directive] = 1;
		return {name: name, directive: directiveObj};
	},
	getStatusAndDirective3(status) {
		let name = '-';
		let directive = 'default';
		switch (status) {
			case 0: {
				name = 'Đang chờ';
				directive = 'info';
				break;
			}
			case 1: {
				name = 'Sản phẩm phù hợp';
				directive = 'warning';
				break;
			}
			case 128:
			case 64: {
				name = 'Hoàn thành VĐ';
				directive = 'success';
				break;
			}
			// case 128: {
			// 	name = 'Đã thanh toán';
			// 	directive = 'dark';
			// 	break;
			// }
			case 2: {
				name = 'Đề xuất giao dịch';
				directive = 'primary';
				break;
			}
			case 4: {
				name = 'Duyệt mua';
				directive = 'success';
				break;
			}
			case 8: {
				name = 'Đã từ chối';
				directive = 'danger';
				break;
			}
			case 16: {
				name = 'Đã hủy';
				directive = 'default';
				break;
			}
			case 2056: {
				name = 'Đang vận chuyển';
				directive = 'warning';
				break;
			}
		}
		let directiveObj = {label:1};
		directiveObj['text-'+directive] = 1;
		return {name: name, directive: directiveObj};
	},
	getStatusAndDirectiveXuatHang(status) {
		let name = '-';
		let directive = 'default';
		let color = '';
		
		// {id: 0, name: 'Đang chờ', color: '#AF00CC', active: 0},
		// {id: 2, name: 'Duyệt mua', color: '#63BA46', active: 0},
		// {id: 4, name: 'Chờ TT', color: '#0E9F96', active: 0},
		// {id: 5, name: 'Duyệt TT', color: '#057FBB', active: 0},
		// {id: 6, name: 'Chờ xuất', color: '#D2AC24', active: 0},
		// {id: 7, name: 'Hoàn thành', color: '#1DD100', active: 0},
		switch (status) {
			case 0: {
				name = 'Đang chờ';
				directive = 'info';
				color = '#AF00CC';
				break;
			}
			case 2: {
				name = 'Duyệt mua';
				directive = 'success';
				color: '#63BA46';
				break;
			}
			case 1: {
				name = 'Đã từ chối';
				directive = 'danger';
				color = '#DE0000';
				break;
			}
			case 3: {
				name = 'Đã hủy';
				directive = 'danger';
				color = '#DE0000';
				break;
			}
			case 4: {
				name = 'Chờ thanh toán';
				directive = 'warning';
				color = '#0E9F96';
				break;
			}
			case 5: {
				name = 'Chờ duyệt TT';
				directive = 'warning';
				color = '#057FBB';
				break;
			}
			case 6: {
				name = 'Chờ xuất';
				directive = 'warning';
				color = '#D2AC24';
				break;
			}
			case 7: {
				name = 'Hoàn thành';
				directive = 'success';
				color: '#1DD100';
				break;
			}
			case 8: {
				name = 'Từ chối TT';
				directive = 'danger';
				color = '#DE0000';
				break;
			}
		}
		let directiveObj = {label:1};
		directiveObj['text-'+directive] = 1;
		return {name: name, directive: directiveObj, color: color};
	},
	getStatusAndDirective(status) {
		let name = '-';
		let directive = 'default';
		switch (status) {
			case 0: {
				name = 'Đang chờ';
				directive = 'info';
				break;
			}
			case 1: {
				name = 'Sản phẩm phù hợp';
				directive = 'warning';
				break;
			}
			case 64: {
				name = 'Hoàn thành VĐ';
				directive = 'success';
				break;
			}
			case 128: {
				name = 'Đã thanh toán';
				directive = 'dark';
				break;
			}
			case 2: {
				name = 'Đề xuất giao dịch';
				directive = 'primary';
				break;
			}
			case 4: {
				name = 'Duyệt mua';
				directive = 'success';
				break;
			}
			case 8: {
				name = 'Đã từ chối';
				directive = 'danger';
				break;
			}
			case 16: {
				name = 'Đã hủy';
				directive = 'default';
				break;
			}
			case 2056: {
				name = 'Đang vận chuyển';
				directive = 'warning';
				break;
			}
		}
		let directiveObj = {label:1};
		directiveObj['text-'+directive] = 1;
		return {name: name, directive: directiveObj};
	},

	getStatusAndColorNhatKy(shipping) {
		let name = 'Chờ kiểm';
		let color = '#F5BE2E';
		if (shipping.tested_date) {
			if (shipping.kcs_accept) {
				name = 'Đạt';
				color = '#63BA46';
			} else {
				name = 'Không đạt';
				color = '#DE0000';
			}
		}
		return {name: name, color: color};
	},
	numFormat(num, dec, isHasCurrency) {
		if (typeof num === "undefined") return "";
		// let preferences = user.getUserRefs();
		let decimals = dec || 0;
		let lang = "en";
		let decimalPoint = lang === "vi" ? "," : ".";
		let separator = lang === "vi" ? "." : ",";
		const currency = lang === "vi" ? "VNĐ" : "";
		if (isHasCurrency) {
			return number_format(Number(num), decimals, decimalPoint, separator) + ` ${currency}`;
		}
		return number_format(Number(num), decimals, decimalPoint, separator);
	},
	removeComma(value) {
		if (!value) {
			return '';
		}
		if (typeof value === 'string' ) {
			return Number(value.replace(/,/g, ""));
		}
		return value;
	},
	momentFormat(datetime = undefined, format = "DD/MM/YYYY") {
		return moment(datetime).format(format);
	},
	momentFormatLocale(datetime = undefined, format = "DD/MM/YYYY", extra = 7) {
		return moment(datetime)
			.add(extra, "hours")
			.format(format);
	},
	buildUrl(url, parameters) {
		let qs = "";
		console.log(parameters);
		for (const key in parameters) {
			if (parameters.hasOwnProperty(key)) {
				const value = parameters[key];
				console.log(parameters);
				qs += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
			}
		}
		if (qs.length) {
			qs = qs.substring(0, qs.length - 1); //chop off last "&"
			url = url + "?" + qs;
		}
		return url;
	},
	removeVietnameseAccent(str) {
		return str
			? str
					.normalize("NFD")
					.replace(/[\u0300-\u036f]/g, "")
					.replace(/đ/g, "d")
					.replace(/Đ/g, "D")
			: "";
	},
	averageGeolocation(coords) {
		if (coords.length === 1) {
			return coords[0];
		}

		let x = 0.0;
		let y = 0.0;
		let z = 0.0;

		for (let coord of coords) {
			let latitude = (coord.latitude * Math.PI) / 180;
			let longitude = (coord.longitude * Math.PI) / 180;

			x += Math.cos(latitude) * Math.cos(longitude);
			y += Math.cos(latitude) * Math.sin(longitude);
			z += Math.sin(latitude);
		}

		let total = coords.length;

		x = x / total;
		y = y / total;
		z = z / total;

		let centralLongitude = Math.atan2(y, x);
		let centralSquareRoot = Math.sqrt(x * x + y * y);
		let centralLatitude = Math.atan2(z, centralSquareRoot);

		return {
			latitude: (centralLatitude * 180) / Math.PI,
			longitude: (centralLongitude * 180) / Math.PI
		};
	},
	baseLocalSort(data, key = "name") {
		var collator = new Intl.Collator(undefined, {
			numeric: true,
			sensitivity: "base"
		});
		return data.sort((a, b) => {
			return collator.compare(a[key], b[key]);
		});
	},
	zeroPad(num, places) {
		var zero = places - num.toString().length + 1;
		return Array(+(zero > 0 && zero)).join("0") + num;
	},
	getWorkShifts(arr = false) {
		let shifts = {
			"1": "Ca 1",
			"2": "Ca 2",
			"3": "Ca 3",
			hc: "Hành chánh",
			bx: "Bốc xếp",
			sale: "Sales",
			ktvn: "Kỹ thuật vùng nuôi",

			fillet: "Tổ Fillet",
			suaca: "Tổ Sửa cá",
			xepkhuon1: "Tổ Xếp khuôn 1",
			xepkhuon2: "Tổ Xếp khuôn 2",
			thanhpham1: "Tổ Thành phẩm 1",
			thanhpham2: "Tổ Thành phẩm 2",
			kholanh: "Tổ Kho lạnh",
			surimi: "Tổ Surimi"
		};
		if (!arr) {
			return shifts;
		}
		let workShifts = [];
		for (let k in shifts) {
			workShifts.push({
				value: k,
				name: shifts[k]
			});
		}
		return workShifts;
	},
	locateWorkShift(key) {
		let shifts = this.getWorkShifts();
		return shifts.hasOwnProperty(key) ? shifts[key] : "-";
	},
	setLocal(k, v) {
		if (typeof localStorage === "object" && localStorage) {
			localStorage.setItem(k, v);
		}
	},
	getLocal(k) {
		if (typeof localStorage === "object" && localStorage) {
			return localStorage.getItem(k);
		}
		return null;
	}
};

export function number_format(number, decimals, decPoint, thousandsSep) {
	// eslint-disable-line camelcase
	//  discuss at: http://locutus.io/php/number_format/
	// original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	// improved by: Kevin van Zonneveld (http://kvz.io)
	// improved by: davook
	// improved by: Brett Zamir (http://brett-zamir.me)
	// improved by: Brett Zamir (http://brett-zamir.me)
	// improved by: Theriault (https://github.com/Theriault)
	// improved by: Kevin van Zonneveld (http://kvz.io)
	// bugfixed by: Michael White (http://getsprink.com)
	// bugfixed by: Benjamin Lupton
	// bugfixed by: Allan Jensen (http://www.winternet.no)
	// bugfixed by: Howard Yeend
	// bugfixed by: Diogo Resende
	// bugfixed by: Rival
	// bugfixed by: Brett Zamir (http://brett-zamir.me)
	//  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	//  revised by: Luke Smith (http://lucassmith.name)
	//    input by: Kheang Hok Chin (http://www.distantia.ca/)
	//    input by: Jay Klehr
	//    input by: Amir Habibi (http://www.residence-mixte.com/)
	//    input by: Amirouche
	//   example 1: number_format(1234.56)
	//   returns 1: '1,235'
	//   example 2: number_format(1234.56, 2, ',', ' ')
	//   returns 2: '1 234,56'
	//   example 3: number_format(1234.5678, 2, '.', '')
	//   returns 3: '1234.57'
	//   example 4: number_format(67, 2, ',', '.')
	//   returns 4: '67,00'
	//   example 5: number_format(1000)
	//   returns 5: '1,000'
	//   example 6: number_format(67.311, 2)
	//   returns 6: '67.31'
	//   example 7: number_format(1000.55, 1)
	//   returns 7: '1,000.6'
	//   example 8: number_format(67000, 5, ',', '.')
	//   returns 8: '67.000,00000'
	//   example 9: number_format(0.9, 0)
	//   returns 9: '1'
	//  example 10: number_format('1.20', 2)
	//  returns 10: '1.20'
	//  example 11: number_format('1.20', 4)
	//  returns 11: '1.2000'
	//  example 12: number_format('1.2000', 3)
	//  returns 12: '1.200'
	//  example 13: number_format('1 000,50', 2, '.', ' ')
	//  returns 13: '100 050.00'
	//  example 14: number_format(1e-8, 8, '.', '')
	//  returns 14: '0.00000001'

	number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
	var n = !isFinite(+number) ? 0 : +number;
	var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
	var sep = typeof thousandsSep === "undefined" ? "," : thousandsSep;
	var dec = typeof decPoint === "undefined" ? "." : decPoint;
	var s = "";

	var toFixedFix = function(n, prec) {
		if (("" + n).indexOf("e") === -1) {
			return +(Math.round(n + "e+" + prec) + "e-" + prec);
		} else {
			var arr = ("" + n).split("e");
			var sig = "";
			if (+arr[1] + prec > 0) {
				sig = "+";
			}
			return (+(Math.round(+arr[0] + "e" + sig + (+arr[1] + prec)) + "e-" + prec)).toFixed(prec);
		}
	};

	// @todo: for IE parseFloat(0.55).toFixed(0) = 0;
	s = (prec ? toFixedFix(n, prec).toString() : "" + Math.round(n)).split(".");
	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	}
	if ((s[1] || "").length < prec) {
		s[1] = s[1] || "";
		s[1] += new Array(prec - s[1].length + 1).join("0");
	}

	return s.join(dec);
}
